import { Injectable } from '@angular/core';
import { ServiceCenterLocation } from './models/service-center-location';
import { ScSnapshotStore } from './sc-snapshot-store';

@Injectable({ providedIn: 'root' })
export class LocationCacheStoreService extends ScSnapshotStore<ServiceCenterLocation> {
  protected readonly dbName = 'fleethd-sc-loc';
  protected readonly storeName = 'locations';
  protected readonly schemaVersion = 1;
}
